import React from 'react';
import styled from 'styled-components';

import { Project } from '../../../utils/models';

import russelsmithLogo from '../../../assets/images/brand.png';


interface Props {
    cdrNumber: string;
    projectDetails: Project;
}

const ReportTitleContainer =  styled.div`
    font-size: 1.5rem;
    font-weight: 900;
    text-transform: uppercase;
    border: 3px solid black;
    width: 70%;
    text-align: center;
    padding: 0.875rem;
`;

const ReportCDRContainer =  styled.div`
    font-size: 1.25rem;
    font-weight: 800;
    text-transform: uppercase;
    border: 2px solid black;
    width: 70%;
    text-align: center;
    padding: 0.5rem;
`;

const ContentContainer = styled.div`
	min-height: 95rem;
`;

const Image = styled.img`
    width: 15rem;
    height: auto;
    object-fit: contain !important;
`;

const Heading = styled.h1`
    font-size: 1.5rem;
    font-weight: 900;
    margin: 1.5rem 0;
`;

const CustomCDRCover: React.FC<Props> = ({ cdrNumber, projectDetails: { inspectionTypeName, organisation, facility } }) => {
    return (
        <div className="p-3 pdf-page" aria-label="Information Sheet">
            <ContentContainer className="border-dark flex-column d-flex justify-content-center">
                <div className="d-flex justify-content-center align-items-center">
                    <Image src={russelsmithLogo} alt="Russel Smith" />
                </div>

                <div className="d-flex justify-content-center align-items-center my-5">
                    <ReportTitleContainer>
                        {inspectionTypeName}
                    </ReportTitleContainer>
                </div>
                
                <div className="d-flex  justify-content-center align-items-center">
                    <Image src={organisation.organisationLogo}  alt={organisation.organisationName} />
                </div>

                <div className="d-flex  justify-content-center align-items-center">
                    <Heading>{facility.facilityName}</Heading>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                    <ReportCDRContainer>
                        CDR Number: {cdrNumber}
                    </ReportCDRContainer>
                </div>
            </ContentContainer>
        </div>
    );
};

export default CustomCDRCover;
